<template>
  <div id="app">
    <h1>Email Signature Generator</h1>
    <SignatureForm/>
  </div>
</template>

<script>
import SignatureForm from './components/SignatureForm.vue'

export default {
  name: 'app',
  components: {
    SignatureForm
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700');
  h1 {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 400;
    margin: 15px 0 0px 10px;
  }
</style>


